import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Admin", path: "/admin" },
  { label: "Users", path: "/users" },
];

const AuthNavbar = ({ setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
    if (window.innerWidth < 1024 && setIsSidebarOpen) {
      setIsSidebarOpen(false);
    }
  };

  const handleLogout = () => {
    // Clear all localStorage data (or specific keys like 'token', 'user')
    localStorage.clear();
    // Redirect to login / home page
    navigate("/");
  };

  return (
    <nav
      style={{ background: "#111111", borderBottom: "1px solid #2a2a2a" }}
      className="fixed top-0 w-full z-50"
    >
      <div className="px-6 mx-auto flex justify-between items-center h-14">
        {/* Brand / Sidebar toggle for mobile */}
        <span
          className="cursor-pointer"
          style={{
            color: "#C9A84C",
            fontWeight: 700,
            fontSize: "15px",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
          }}
          onClick={() => {
            if (window.innerWidth < 1024 && setIsSidebarOpen) {
              setIsSidebarOpen((prev) => !prev);
            }
          }}
        >
          Admin Portal
        </span>

        {/* Nav links + Logout */}
        <div className="flex items-center gap-6">
          {navLinks.map(({ label, path }) => {
            const isActive = pathname === path;
            return (
              <span
                key={path}
                onClick={() => handleNavigation(path)}
                style={{
                  color: isActive ? "#C9A84C" : "#cccccc",
                  fontSize: "14px",
                  letterSpacing: "0.04em",
                  textDecoration: "none",
                  fontWeight: isActive ? 600 : 400,
                  borderBottom: isActive
                    ? "2px solid #C9A84C"
                    : "2px solid transparent",
                  paddingBottom: "2px",
                  transition: "color 0.2s",
                  cursor: "pointer",
                }}
              >
                {label}
              </span>
            );
          })}
          
          {/* Logout Button */}
          <button
            onClick={handleLogout}
            style={{
              background: "transparent",
              border: "1px solid #C9A84C",
              borderRadius: "4px",
              color: "#C9A84C",
              fontSize: "13px",
              padding: "5px 12px",
              fontWeight: 500,
              letterSpacing: "0.04em",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#C9A84C";
              e.currentTarget.style.color = "#111111";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.color = "#C9A84C";
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default AuthNavbar;



// import React from "react";
// import { useNavigate, useLocation } from "react-router-dom";

// const navLinks = [
//   { label: "Users", path: "/users" },
// ];

// const AuthNavbar = ({ setIsSidebarOpen }) => {
//   const navigate = useNavigate();
//   const { pathname } = useLocation();

//   const handleNavigation = (path) => {
//     navigate(path);
//     // Optional: close mobile sidebar if needed
//     if (window.innerWidth < 1024 && setIsSidebarOpen) {
//       setIsSidebarOpen(false);
//     }
//   };

//   return (
//     <nav
//       style={{ background: "#111111", borderBottom: "1px solid #2a2a2a" }}
//       className="fixed top-0 w-full z-50"
//     >
//       <div className="px-6 mx-auto flex justify-between items-center h-14">
//         {/* Brand */}
//         <span
//           className="cursor-pointer"
//           style={{
//             color: "#C9A84C",
//             fontWeight: 700,
//             fontSize: "15px",
//             letterSpacing: "0.12em",
//             textTransform: "uppercase",
//           }}
//           onClick={() => {
//             if (window.innerWidth < 1024 && setIsSidebarOpen) {
//               setIsSidebarOpen((prev) => !prev);
//             }
//           }}
//         >
//           Admin Portal
//         </span>

//         {/* Nav links – now interactive */}
//         <div className="flex items-center gap-8">
//           {navLinks.map(({ label, path }) => {
//             const isActive = pathname === path;
//             return (
//               <span
//                 key={path}
//                 onClick={() => handleNavigation(path)}
//                 style={{
//                   color: isActive ? "#C9A84C" : "#cccccc",
//                   fontSize: "14px",
//                   letterSpacing: "0.04em",
//                   textDecoration: "none",
//                   fontWeight: isActive ? 600 : 400,
//                   borderBottom: isActive
//                     ? "2px solid #C9A84C"
//                     : "2px solid transparent",
//                   paddingBottom: "2px",
//                   transition: "color 0.2s",
//                   cursor: "pointer", // changed from "default"
//                 }}
//               >
//                 {label}
//               </span>
//             );
//           })}
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default AuthNavbar;